import { Bug } from 'lucide-react';

import { DropdownMenuItem } from '@/components/ui/dropdown-menu';

interface Props {
    onSelect: () => void;
}

export function SendFeedbackMenuItem({ onSelect }: Props) {
    return (
        <DropdownMenuItem
            className="gap-2"
            data-testid="MenuItem__sendFeedback"
            onSelect={onSelect}
        >
            <Bug className="h-4 w-4 text-gray-500" />
            Send feedback
        </DropdownMenuItem>
    );
}
